<template>
    <v-layout column class="pb-15">
        <v-row no-gutters>
            <v-col :sm="drawer ? 6 : 2"
                    v-show="$vuetify.breakpoint.smAndUp"
                    style="height: 100vh !important;"
                    :style="drawer ? 'position: fixed; overflow-y: scroll;' : ''"
            >
                <transition name="slide-x-transition" :duration="{ enter: 1000, leave: 800 }">
                    <v-list nav v-show="drawer" class="px-5">
                        <v-row align="center" class="px-5 mb-5" style="position: sticky; top: 0; background-color: #FFFFFF; z-index: 1">
                            <v-col>
                                <div class="montserrat-bold text-uppercase text-left"
                                    :class="$vuetify.breakpoint.mdAndUp ? 'h3' : 'h4'"
                                >
                                    {{ $route.query.title }}
                                </div>
                            </v-col>
                            <v-col class="text-left justify-end" cols="2" v-show="!$vuetify.breakpoint.xsOnly">
                                <i class="bx bx-left-arrow-alt bx-lg font-weight-bold" style="cursor: pointer" @click="drawer = false"></i>
                            </v-col>
                        </v-row>

                        <!-- list of units  -->
                        <v-list-item-group class="text-left">
                            <v-list-item two-line v-for="(unit, index) in units.list" :key="index" @click="changeUnit(unit.id, index)">
                                <v-list-item-content :class="isUnitActive(index)">
                                    <v-list-item-subtitle class="montserrat text-uppercase mb-3">
                                        Unit {{ index + 1}} - {{ unit.id }}
                                    </v-list-item-subtitle>
                                    <h3 class="montserrat-bold">{{ unit.title }}</h3>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </transition>
            </v-col>

            <!-- books here -->
            <v-col :sm="drawer ? 6 : 8"
                cols="12" style="margin-top: -50px; height: 100%"
                :style="drawer ? 'position: fixed; left: 50%; overflow-y: scroll' : ''"
            >
                <div class="text-left ml-5" style="position: sticky; top: 2rem; z-index: 1"
                    v-show="!drawer && $vuetify.breakpoint.smAndUp"
                >
                    <v-icon style="background-color: rgba(0, 0, 0, 0.5)"  color="white"
                        @click="drawer = !drawer"
                        class="pa-3 rounded-lg bx bx-menu"
                    >
                    </v-icon>
                </div>

                <LayoutSelector />
            </v-col>
        </v-row>

        <!-- menu for mobile  -->
        <!-- to be fixed here width doesnt stretch to end  -->
        <v-dialog v-model="mobileDrawer" scrollable transition="dialog-bottom-transition" class="mobile-menu">
            <v-card width="100%" color="#FFFFFF" class="px-3 card-test">
                <v-list nav v-show="mobileDrawer" class="nav-list mt-5">
                    <v-row align="center" class="mb-5" style="position: sticky; top: 0; background-color: #FFFFFF; z-index: 1">
                        <v-col>
                            <div class="montserrat-bold text-uppercase text-left" :class="$vuetify.breakpoint.smAndUp ? 'h3' : 'h5'">
                                {{ $route.query.title }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-list-item-group class="text-left">
                        <v-list-item three-line v-for="(unit, index) in units.list" :key="index" @click="changeUnit(unit.id, index)">
                            <v-list-item-content :class="isUnitActive(index)">
                                <v-list-item-subtitle class="montserrat text-uppercase mb-3">
                                    Unit {{ index + 1 }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle class="montserrat-bold dark-text">
                                    <h3>{{ unit.title }}</h3>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </v-dialog>

        <!-- bottom controls for mobile screens  -->
        <v-flex class="bottom-controls pa-5" v-show="$vuetify.breakpoint.xsOnly && isVisible">
            <v-row>
                <v-col><i @click="changeUnit(null, null, 'previous')" class='bx bxs-chevron-left bx-md'></i> </v-col>
                <v-col @click="mobileDrawer = true"><i class='bx bx-menu bx-md'></i></v-col>
                <v-col><i @click="changeUnit(null, null, 'next')" class='bx bxs-chevron-right bx-md'></i> </v-col>
            </v-row>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios"
import { mapState } from "vuex"
import LayoutSelector from "@/components/LayoutSelector.vue"
import { bus } from "@/main"

export default {
    components: { LayoutSelector },
    data () {
        return {
            drawer: false,
            mobileDrawer: false,
            isVisible: true,
            units: {
                displayedIndex: null,
                show: false,
                status: null,
                list: null
            },
            displayedUnit: null
        }
    },

    computed: {
        unitId () {
            return this.units.list[this.units.displayedIndex].id
        },
        component () {
            return "travel-english"
        },
        ...mapState("user", ["user"])
    },

    watch: {
        user () {
            this.getUnitsList(this.$route.query.bookid)
        }
    },

    mounted () {
        window.addEventListener("scroll", this.onScroll)
        this.getUnitsList(this.$route.query.bookid)
    },

    beforeDestroy () {
        window.removeEventListener("scroll", this.onScroll)
    },

    methods: {
        // computed
        isUnitActive (index) {
            return index == this.units.displayedIndex ? "active" : ""
        },

        async getUnitsList (textbookId) {
            // to refresh data
            this.units.status = null
            this.units.list = null

            this.units.show = true

            const url = "megatalking/v1/web-book-units/" + textbookId
            const response = await axios.get(url)

            // shows 3 units only when user is guest
            this.units.list = this.user.userType == "guest" ? response.data.slice(0, 3) : response.data
            this.units.status = true
            const unitTitleToBeDisplayed = this.$route.query.unitname ? this.$route.query.unitname : response.data[0].title
            this.displayedUnit = unitTitleToBeDisplayed

            const unitToBeDisplayed = this.$route.query.unit ? this.$route.query.unit : response.data[0].id
            this.units.displayedIndex = 0
            this.$store.dispatch("units/getElements", unitToBeDisplayed)
                .then(() => {
                    bus.$emit("toggleModal", false, "success", "")
                })
                .catch(() => {
                    bus.$emit("toggleModal", true, "error", "error")
                })
        },

        changeUnit (id, index, type = null) {
            bus.$emit("toggleModal", true, "loading", "loading")
            let unitId

            if (["previous", "next"].includes(type)) {
                if (type == "previous") {
                    this.units.displayedIndex != 0 ? this.units.displayedIndex -= 1 : bus.$emit("toggleModal", true, "error", "당신은 이미 첫 번째 단위에 있습니다.")
                }
                else if (type == "next") {
                    this.units.displayedIndex == this.units.list.length ? bus.$emit("toggleModal", true, "error", "당신은 마지막 단위에 도달했습니다.") : this.units.displayedIndex += 1
                }
                const unit = this.units.list[this.units.displayedIndex]
                unitId = unit.id
                this.displayedUnit = unit.title
            }
            else {
                // gets the unit's data via vuex
                this.units.displayedIndex = index
                unitId = id
                this.displayedUnit = this.units.list[index].title
            }

            this.$store.dispatch("units/getElements", unitId)
                .then(() => {
                    this.drawer = false
                    this.mobileDrawer = false
                    bus.$emit("toggleModal", false, "success", "")
                })
                .catch(err => {
                    bus.$emit("toggleModal", true, "error", err.message)
                })
        },

        onScroll () {
            const currentScrollPosition =
                window.pageYOffset || document.documentElement.scrollTop
            if (currentScrollPosition < 0) {
                return
            }
            // Stop executing this function if the difference between
            // current scroll position and last scroll position is less than some offset
            // if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
            //     return;
            // }
            this.isVisible = currentScrollPosition < this.lastScrollPosition || document.documentElement.scrollTop == (document.documentElement.offsetTop + document.documentElement.offsetHeight - window.innerHeight)
            this.lastScrollPosition = currentScrollPosition
        }
    }
}
</script>

<style scoped>
.unit-list {
    word-break: break-all !important;
    text-overflow: ellipsis;
    white-space: normal !important;
    overflow: hidden;
}

.dark-text {
    color: black !important;
}

.unit-list.active {
    background-color: #e9e5e5;
}

span.title {
    font-size: 0.8em !important;
}

.bottom-controls {
    position: fixed;
    bottom: 0;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    border-radius: 10px 10px 0 0;
    text-align: center;
}
.bottom-controls i {
    color: #fff;
}

.mobile-menu {
    width: 100% !important;
    position: relative;
}

.card-test {
    transition: 0.5s all ease !important;
    max-height: 70vh;
    position: absolute;
    bottom: 0;
    left: 0;
    overflow: auto;
}

.active {
    background: rgba(167, 238, 149, 0.3);
}

.box.disabled {
    pointer-events: none;
    opacity: 0.5;
    position: relative;
}
.box.disabled::before {
    content: '\2713';
    color: white;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
